module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-08.672d1dfe.png";